<template>
	<div>
		<div class="top-btn">
			<div class="issue" style="height: 155px;line-height: 155px;">广告宣传</div>
		</div>
		<div class="link">
			<div class="title">
				<div class="line"></div>
				<div class="text">浏览记录</div>
			</div>
			<div class="line"></div>
			<div style="padding: 0 18px 18px 18px">
				<div class="card" v-for="(item, index) in history"  @click="link(item)">
					<img v-if="(item.root==1&&item.category==1||item.category==3||item.category==4)||(item.root==2&&item.category==2)||(item.root==3&&item.category==1)||(item.root==5&&item.category==6)||(item.root==6&&item.category==7)||(item.root==10&&item.category<=2)" :src="decodeURIComponent(item.image)" class="img" alt="" />
					<img v-else :src="decodeURIComponent(item.logo)" class="img" alt="">
					<div :title="item.name" v-if="(item.root==1&&item.category==1||item.category==3||item.category==4)||(item.root==2&&item.category==2)||(item.root==3&&item.category==1)||(item.root==5&&item.category==6)||(item.root==6&&item.category==7)||(item.root==10&&item.category<=2)" class="text">{{ item.name }}</div>
					<div v-else class="text" :title="item.company">{{ item.company }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props:['history'],
		methods: {
			link(item){
				let routeData = this.$router.resolve({ path: 'productDetail', query: {id:item.id}});
				window.open(routeData.href, '_blank');
			},
		}
	}
</script>
<style scoped>
	.right .top-btn .issue {
		text-align: center;
		background-color: #4a73ff;
		line-height: 46px;
		height: 46px;
		border-radius: 10px;
		color: #ffffff;
		font-size: 16px;
		cursor: pointer;
	}
	.right .top-btn .serve {
		text-align: center;
		border: 1px solid #4a73ff;
		background-color: #ffffff;
		line-height: 46px;
		height: 46px;
		border-radius: 10px;
		color: #4a73ff;
		font-size: 16px;
		margin-top: 10px;
		cursor: pointer;
	}
	.link {
		background-color: #ffffff;
		margin-top: 10px;
		border-radius: 10px;
		cursor: pointer;
	}
	.link .title {
		display: flex;
		padding-top: 20px;
	}
	.right .link .title .line {
		width: 4px;
		height: 24px;
		background-color: #4a73ff;
		margin-right: 11px;
	}
	.link .text {
		color: #222222;
		font-size: 19px;
		font-weight: 600;
	}
	.right .link .line {
		width: 100%;
		height: 0.4px;
		background-color: #efefef;
		margin: 0 10px 15px 0;
	}
	.link .card {
		display: flex;
		margin-bottom: 20px;
	}
	.link .card .img {
		width: 40px;
		height: 40px;
	}
	.link .card .text {
		font-size: 15px;
		font-weight: 600;
		margin-top: 10px;
		margin-left: 20px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.card .text:hover {
		color: #4a73ff;
	}
</style>